namespace $.$$ {
	export class $shm_showcase_demo_dotsloader extends $.$shm_showcase_demo_dotsloader {
		content() { return this.loading() ? [ this.Loader() ] : [] }
	}
}
